import { Box, DialogContentText, Stack, Typography } from "@mui/material";
import { AttachmentItem } from "Common/Components";
import { CONFIRMATION_TYPES, UI_ELEMENTS } from "Common/Constants";
import type { IConfirmationContent } from "Common/Interfaces";

interface IGetConfirmationContent {
  activeElement: UI_ELEMENTS | null;
  rejectedFiles: File[];
}

export const getConfirmationContent = (props: IGetConfirmationContent): IConfirmationContent | null => {
  const { activeElement, rejectedFiles } = props;
  switch (activeElement) {
    case UI_ELEMENTS.INVALID_CONFIRMATION:
      return {
        title: "Unsupported file types!",
        message: (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
              p: 2,
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
              }}
            >
              Below file types are not supported
            </Typography>
            <Stack
              spacing={2}
              sx={{
                alignItems: "center",
                mt: 2,
                width: "100%",
              }}
            >
              {rejectedFiles.map((file) => (
                <AttachmentItem key={file.name} file={file} isRejected={true} />
              ))}
            </Stack>
          </Box>
        ),
        event: CONFIRMATION_TYPES.CANCEL,
        confirmButtonText: "Ok",
        hideCancelButton: true,
        dialogWidth: "sm",
      };

    case UI_ELEMENTS.LIMIT_EXCEEDED_CONFIRMATION:
      return {
        title: "File count exceeded!",
        message: (
          <DialogContentText
            component={"span"}
            sx={{
              textAlign: "center",
            }}
          >
            More than 5 files cannot be selected.
          </DialogContentText>
        ),
        event: CONFIRMATION_TYPES.CANCEL,
        confirmButtonText: "Ok",
        hideCancelButton: true,
      };

    case UI_ELEMENTS.CANCEL_CONFIRMATION:
      return {
        title: "Confirm Cancellation !",
        message: (
          <DialogContentText
            component={"span"}
            sx={{
              textAlign: "center",
            }}
          >
            Changes you made so far will not be saved. Are you sure you want to cancel ?
          </DialogContentText>
        ),
        event: CONFIRMATION_TYPES.CANCEL,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      };

    default:
      return null;
  }
};
